import { useTenant } from "@/hooks/useTenant";
import { useMemo } from "react";

/**
 * SIM-3115: read what the server says this user may do, rather than deriving it from a role string.
 * `useUserRole` is still right for identity-shaped questions ("is this a super admin?"). This is
 * for policy-shaped ones ("may this user manage dashboards?"), where the answer is the server's to
 * give.
 */
export function useCapabilities() {
  const { currentCapabilities, isLoading } = useTenant();
  return useMemo(() => {
    // Absent field ⇒ no capabilities, so this fails CLOSED. A cached bundle can
    // outlive the payload it was built against, making that a real rollout
    // state rather than only a test convenience.
    const capabilities = currentCapabilities ?? [];
    return {
      can: (capability: string) => capabilities.includes(capability),
      /** Add, edit or delete a dashboard — Looker or SimplySpark. */
      canManageDashboards: capabilities.includes("dashboards.manage"),
      /** See every dashboard in the tenant, not only the ones assigned to you. */
      canViewAllDashboards: capabilities.includes("dashboards.viewAll"),
      isLoading,
    };
  }, [currentCapabilities, isLoading]);
}
